import { useQueryFeatureFlags } from "@hooks/useQueryFeatureFlags";
import React from "react";
import { GeneralErrorPage } from "../../../shared/components/GeneralErrorPage";
import { MemberPlaidModals } from "../../../utils/usePlaidLink";
import { LoadingPlaceholder } from "../../LoadingPlaceholder";
import { OptVerification } from "../../OptVerification";
import { CurrentAccountNameProvider } from "../../../v3/providers/CurrentAccountNameProvider";
import { SystemLog } from "../SystemLog";
import { MemberRoutes } from "./MemberRoutes";
import { useInitMemberApp } from "./useInitMemberApp";

export const AuthenticatedMemberApp: React.FC = () => {
  const initMemberApp = useInitMemberApp();
  // PLA-3618: useFocusedFeatures answers every flag `false` until this resolves,
  // and TaxWithholdings turns that `false` into a Redirect.
  const queryFeatureFlags = useQueryFeatureFlags();

  if (initMemberApp.isLoading || queryFeatureFlags.isLoading) {
    return <LoadingPlaceholder />;
  }

  if (initMemberApp.isError || !initMemberApp.currentAccount) {
    return <GeneralErrorPage />;
  }

  return (
    <CurrentAccountNameProvider account={initMemberApp.currentAccount.account}>
      <SystemLog />
      <OptVerification />
      <MemberPlaidModals />
      <MemberRoutes />
    </CurrentAccountNameProvider>
  );
};
